import ApiAcces from "@/shared/services/ApiAcces";
import type UserSetting from "../models/UserSetting";
import type IUserSettingService from "../contracts/IUserSettingService";

export default class UserSettingService
  extends ApiAcces
  implements IUserSettingService
{
  async getKeys(): Promise<UserSetting[]> {
    return (await this.api.get("/api/UserSettings/keys")).data;
  }

  async get(key: number): Promise<string> {
    return (await this.api.get(`/api/UserSettings?settingsKey=${key}`)).data;
  }

  async set(key: number, newValue: string): Promise<void> {
    await this.api.post(
      `/api/UserSettings?settingsKey=${key}`,
      JSON.stringify(newValue),
      {
        headers: { "Content-Type": "application/json" },
      },
    );
  }
}
